<script lang="ts">
    import {getLocalization} from 'src/core';
    import {getModalContext} from './modal-context';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';

    export let action: 'cancel' | 'acknowledge' = 'cancel';
    export let dataQa: string | null = null;

    const localize = getLocalization();
    const context = getModalContext();

    function handler() {
        if (action === 'cancel') {
            context.modalWindowActions.cancel();
            return;
        }
        if (action === 'acknowledge') {
            context.modalWindowActions.acknowledge();
            return;
        }
        throw new Error('Unknown modal close action!');
    }

</script>

<KpButton {dataQa} on:click={handler}>
    {localize(/* @kp-localization commons.zavrit */ 'commons.zavrit')}
</KpButton>
